/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESDocumentService' store object.
 * @namespace ACESDocumentServiceSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESDocumentService';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static postAcesdbsFiles = state => state[selectors.moduleIdentifier].postAcesdbsFiles.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static isFetchingPostAcesdbsFiles = state =>
    state[selectors.moduleIdentifier].isFetchingPostAcesdbsFiles.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static postAcesdbsFilesError = state =>
    state[selectors.moduleIdentifier].postAcesdbsFilesError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static getAcesdbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].getAcesdbsFilesByFileId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static isFetchingGetAcesdbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].isFetchingGetAcesdbsFilesByFileId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static getAcesdbsFilesByFileIdError = state =>
    state[selectors.moduleIdentifier].getAcesdbsFilesByFileIdError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static deleteAcesdbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].deleteAcesdbsFilesByFileId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static isFetchingDeleteAcesdbsFilesByFileId = state =>
    state[selectors.moduleIdentifier].isFetchingDeleteAcesdbsFilesByFileId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESDocumentServiceSelectors
   */
  static deleteAcesdbsFilesByFileIdError = state =>
    state[selectors.moduleIdentifier].deleteAcesdbsFilesByFileIdError.payload;
}
